import { useEffect, useRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './EditorButton.css';

interface EditorButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  kind?: 'primary' | 'editor' | 'action' | 'none';
  active?: boolean;
  children?: ReactNode;
}

export default function EditorButton({
  kind = 'editor',
  active = false,
  disabled,
  children,
  className,
  ...rest
}: EditorButtonProps) {
  const rootNode = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (disabled && rootNode.current != null) {
      rootNode.current.blur();
    }
  }, [disabled]);

  const classes = [
    kind === 'action' || kind === 'primary' ? 'Action' : '',
    kind === 'primary' ? 'PrimaryInteraction' : '',
    kind === 'editor' ? 'EditorButton' : '',
    kind === 'none' ? 'NoBackground' : '',
    active ? 'is-active' : '',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={rootNode}
      className={classes}
      disabled={disabled ?? false}
      {...rest}
    >
      {children}
    </button>
  );
}
